import { render, staticRenderFns } from "./qcApp.vue?vue&type=template&id=4c6bffaa&scoped=true"
import script from "./qcApp.vue?vue&type=script&lang=js"
export * from "./qcApp.vue?vue&type=script&lang=js"
import style0 from "./qcApp.vue?vue&type=style&index=0&id=4c6bffaa&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6bffaa",
  null
  
)

export default component.exports